export default __webpack_public_path__ + "static/media/profile-image.0357bd5d.png";